/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inclusive_Basic_Frog_TreatInputs */

const fr_inclusive_basic_frog_treat = /** @type {(inputs: Inclusive_Basic_Frog_TreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge a mettre`)
};

/**

* @param {Inclusive_Basic_Frog_TreatInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const inclusive_basic_frog_treat = /** @type {((inputs?: Inclusive_Basic_Frog_TreatInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inclusive_Basic_Frog_TreatInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_inclusive_basic_frog_treat(inputs)
});